// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation()

jQuery(document).ready(function($) {

    //Smooth Scroll
    $('a[href*="#"]:not([role="tab"]):not(.skip-anchor)').on("click", function() {
    if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
    ) {
        var target = $(this.hash);
        target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
        $("html, body").animate(
            {
            scrollTop: target.offset().top - 125
            },
            1000
        );
        return false;
        }
    }
    });
    //Smooth Scroll on page load if hash
    var hash = window.location.hash;
    if (hash) {
    var target = $(hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
        $("html, body").animate(
        {
            scrollTop: target.offset().top - 125
        },
        1000
        );
        return false;
    }
    }

    // Menu Overlay
    const menuOverlay = document.querySelector('.menu-overlay')
    $(".dropdown").on("show.zf.dropdown", function(e) {
        // console.log('dropdown opened')
        gsap.to('.menu-overlay, .menu-wrapper', {
            autoAlpha: 1, duration: 0.25
        })
    });
    $(".dropdown").on("hide.zf.dropdown", function(e) {
        // console.log('dropdown closed')
        gsap.to('.menu-wrapper', {
            autoAlpha: 0, duration: 0
        })
        gsap.to(menuOverlay, {
            autoAlpha: 0, duration: 0.25
        })
    });
    menuOverlay.addEventListener('click', function() {
        $('.dropdown-pane').foundation('close');
    })
    $(document).on('click', '.dropdown-pane', function (e) {
        e.stopPropagation();
    });

    // Menu Dropdown Wrapper
    $(".menu-wrapper .menu-item.header").each(function() {
        $( this ).nextUntil('.header').andSelf().wrapAll("<div class='inner' />")
        // $(this).next(".header").andSelf().wrapAll("<div class='inner' />")
    });

    // Menu prevent # on parent holders
    $( '.mega-menu a[href="#"]' ).click( function(e) {
        // console.log('prevent empty anchor')
        e.preventDefault();
    });

    // Video Controls
    const allVideos = document.querySelectorAll('video')
    const btnPausePlay = document.querySelectorAll("button.pausePlay");
    const imgPausePlay = document.querySelectorAll("button.pausePlay img");
    const pauseIcon = '/wp-content/themes/unica/assets/images/icon-pause.svg';
    const playIcon = '/wp-content/themes/unica/assets/images/icon-play.svg';

    function videoControl() {
        if (allVideos[0].paused || allVideos[0].ended) {
            // console.log('play')
            // gsap.to("#pause", {morphSVG: {
            // shape: "#pause",
            // type: "linear"
            // }, duration: 0.5, ease: "power1.inOut"})
            gsap.set(imgPausePlay, {
                attr: {src: pauseIcon}
            })
            btnPausePlay.forEach(btn => btn.ariaLabel = 'Pause Video')
            allVideos.forEach(vid => vid.play());
        } else {
            // console.log('pause')
            // gsap.to("#pause", {morphSVG: {
            //     shape: "play"",
            //     type: "linear"
            // }, duration: 0.5, ease: "power1.inOut"})
            gsap.set(imgPausePlay, {
                attr: {src: playIcon}
            })
            btnPausePlay.forEach(btn => btn.ariaLabel = 'Play Video')
            allVideos.forEach(vid => vid.pause());
        }
    }

    btnPausePlay.forEach(btn => {
        // var play = btn.querySelector('[id^="play-icon"]').id;
        // var pause = btn.querySelector('[id^="pause-icon"]').id;
        btn.addEventListener("click", () => {
            videoControl();
        });
    });

    //Mobile Sliders & Sliders

    // slick on mobile
    function slick_on_mobile(slider, settings){
        $(window).on('load resize', function() {
        if ($(window).width() > 430) {
            if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
            }
            return
        }
        if (!slider.hasClass('slick-initialized')) {
            return slider.slick(settings);
        }
        });
    };

    if ($(".home-insurance-categories .categories-slider").length > 0) {
        var insurance_cats_slider = $('.home-insurance-categories .categories-slider');
        var insurance_cats_settings = {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        }
        slick_on_mobile( insurance_cats_slider, insurance_cats_settings);
    }

    if ($(".home-testimonies").length > 0) {
        $('.home-testimonies').slick({
          dots: true,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: $(".slider-arrow.testimony-prev"),
          nextArrow: $(".slider-arrow.testimony-next"),
        //   speed: 500,
          fade: true,
        //   cssEase: 'linear',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                fade: false,
                dots: false,
                // adaptiveHeight: true
              }
            }
          ]
        });
    }

    if ($(".related-products-slider").length > 0) {
        $('.related-products-slider').slick({
          dots: true,
          arrows: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: $(".slider-arrow.related-prev"),
          nextArrow: $(".slider-arrow.related-next"),
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                arrows: false,
                fade: false,
                dots: false
              }
            }
          ]
        });
    }

    if ($(".latest-articles-slider-wrapper").length > 0) {
        $('.latest-articles-slider-wrapper').slick({
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          initialSlide: 1,
          prevArrow: $(".slider-arrow.latest-prev"),
          nextArrow: $(".slider-arrow.latest-next"),
          responsive: [
            {
              breakpoint: 821,
              settings: {
                arrows: false,
                dots: true,
                initialSlide: 0,
              }
            }
          ]
        });
      }

    // Form Label States
    if ($(".gform_wrapper").length > 0) {

      $('body').on('focus click', '.ginput_container:not(.ginput_complex) input:not([type="checkbox"]):not([type="radio"]), textarea', function () {
        $(this).parents(".gfield").addClass("focused");
      });

      $('body').on('focus click', '.ginput_complex input:not([type="checkbox"]):not([type="radio"])', function () {
        $(this).parent().addClass("focused");
      });

      $('body').on('blur', '.ginput_container:not(.ginput_complex) input:not([type="checkbox"]):not([type="radio"]), textarea', function () {
        var inputValue = $(this).val();
        if (inputValue == "" || inputValue === "(___) ___-____") {
          $(this).parents(".gfield").removeClass("focused");
        }
      });

      $('body').on('blur', '.ginput_complex input:not([type="checkbox"]):not([type="radio"])', function () {
        $(this).parent().removeClass("focused");
      });
    }


    /* Toggle Video Modal
  -----------------------------------------*/
	function toggle_video_modal() {

        // Click on video thumbnail or link
        $(".js-trigger-video-modal").on("click", function(e){

            // prevent default behavior for a-tags, button tags, etc.
            e.preventDefault();

            // Grab the video ID from the element clicked
            var id = $(this).attr('data-vimeo-id');

            // Autoplay when the modal appears
            // Note: this is intetnionally disabled on most mobile devices
            // If critical on mobile, then some alternate method is needed
            // var autoplay = '?autoplay=1';

            // Don't show the 'Related Videos' view when the video ends
            // var related_no = '&rel=0';

            // String the ID and param variables together
            var src = 'https://player.vimeo.com/video/'+id;

            // Pass the YouTube video ID into the iframe template...
            // Set the source on the iframe to match the video ID
            $("#vimeo").attr('src', src);

            // Add class to the body to visually reveal the modal
            $("body").addClass("show-video-modal noscroll");

        });

        // Close and Reset the Video Modal
        function close_video_modal() {

          event.preventDefault();

          // re-hide the video modal
          $("body").removeClass("show-video-modal noscroll");

          // reset the source attribute for the iframe template, kills the video
          $("#vimeo").attr('src', '');

        }

        // if the 'close' button/element, or the overlay are clicked
        $('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {
            // call the close and reset function
            close_video_modal();
        });

        // if the ESC key is tapped
        $('body').keyup(function(e) {
            // ESC key maps to keycode `27`
            if (e.keyCode == 27) {
              // call the close and reset function
              close_video_modal();
            }
        });
      }
      toggle_video_modal();
})